import React, { Component } from 'react'
import Adresse from '../client/Adresse';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import DateFormat from '../../../services/DateFormat';

class DevisResume extends Component {

    dateFormat = new DateFormat();

    constructor(props) {
        super(props);
        this.state = {
            numero: this.props.devisResume.numero === 0 ? '' : this.props.devisResume.numero,
            dateCreation: this.dateFormat.toDatePicker(this.props.devisResume.dateCreation),
        };
    }

    handleChange = (champ) => event => {
        this.props.devisResume[champ] = event.target.value;
        this.setState({
            [champ]: event.target.value,
        });
    }

    render() {
        return (
            <div className="devisResume">
                <div className="inlineInputs">
                    <TextField type="number"
                        name="clientNumero"
                        label="Num&eacute;ro de devis"
                        className="numero"
                        value={this.state.numero}
                        inputProps={
                            {
                                readOnly: true,
                                disabled: true,
                            }
                        }
                    />
                    <TextField
                        id="dateCreation"
                        name="dateCreation"
                        label="Date de création"
                        type="date"
                        className="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.dateCreation}
                        onChange={this.handleChange("dateCreation")}
                    />
                </div>
                <Adresse label="Adresse du chantier" className="clientAdrChantier" adresse={this.props.devisResume.adresse} />
            </div>);
    }
}

DevisResume.propTypes = {
    devisResume: PropTypes.object,
};

export default DevisResume


// WEBPACK FOOTER //
// ./src/components/content/devis/DevisResume.js